export  class TermCondition {
  constructor (public product: string, public text: string) {}
}
